<template>
  <div class="new-page-con new-layout-con-sanction">
    <!-- <Header></Header> -->
    <Home></Home>
  </div>
</template>

<script>
import Header from "@/views/newLayout/header.vue";
import Home from "@/views/newLayout/home.vue";
export default {
  components: {
    Header,
    Home,
  },
  data() {
    return {};
  },
  mounted() {
    this.setThemeColor();
  },
  methods: {
    setThemeColor() {
      this.$store.dispatch("app/setThemColor", "#f9722c");
      // this.$store.dispatch("app/setSearchType", "company");
      console.log(this.$store.state.app.themeColor);
    },
  },
};
</script>
